import { DateTime } from 'luxon';
import { Heading, Text } from '@flixbus/honeycomb-react';
import {
  IconDot,
  IconCheckmarkStrong,
  IconCrossed,
  IconCalendar,
  IconPieChart,
  IconDiscount,
} from '@flixbus/honeycomb-icons-react';

import { useVoucher } from '../../context/VoucherProdiver';
import VoucherOverviewItem from './Item';

import OverviewDiscountTypeFields from './OverviewDiscountTypeFields';

import styles from './voucher-overview.module.scss';

const VoucherOverview = () => {
  const { data } = useVoucher();

  const statusIcons = {
    used: IconCheckmarkStrong,
    active: IconDot,
    cancel: IconCrossed,
    inactive: IconDot,
    expired: IconCalendar,
  };

  const fields = OverviewDiscountTypeFields(data.discountType, data);
  const disabledStatuses = ['inactive', 'cancel', 'expired'];

  return (
    <div className={styles.container}>
      <VoucherOverviewItem
        icon={statusIcons[data.status]}
        disabled={disabledStatuses.includes(data.status)}
        content={
          <>
            <Text extraClasses={styles.text}>Status</Text>
            <Heading flushSpace Elem='strong' size={2} extraClasses={styles.status}>
              {data.status === 'cancel' ? 'Disabled' : data.status}
            </Heading>
            <Text small extraClasses={styles.text}>
              Exp.{' '}
              {DateTime.fromISO(data.validityInterval.validUntil).setLocale('de').toLocaleString()}
            </Text>
          </>
        }
      />
      {fields.map(f => (
        <VoucherOverviewItem
          key={f.label}
          icon={f.label === 'Discount value' ? IconDiscount : IconPieChart}
          content={
            <>
              <Text extraClasses={styles.text}>{f.label}</Text>
              <Heading flushSpace Elem='strong' size={2}>
                {f.value}
              </Heading>
            </>
          }
        />
      ))}
    </div>
  );
};

export default VoucherOverview;
